import { useNavigate } from "react-router-dom";
import { useState } from "react";

const CATEGORIES = ["Sports", "Dance", "Walking", "Reading", "Gym", "Social"];

export default function CreateGroup() {
  const navigate = useNavigate();
  
  const [groupName, setGroupName] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [isPrivate, setIsPrivate] = useState(false); // Now used below

  const handleCreate = (e) => {
    e.preventDefault();
    console.log("Group Created:", { groupName, category, description, isPrivate });
    navigate("/home");
  };

  return (
    <div className="page center"> 
      <div className="create-group-wrapper">
        <form className="card" onSubmit={handleCreate} style={{ width: '100%', maxWidth: '500px' }}>
          <h2>Create a New Circle</h2>
          <p className="muted">Start a group and invite people nearby.</p>

          <input
            type="text"
            placeholder="Group Name"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            required
          />

          <div className="activities-section">
            <p className="section-title">Category</p>
            <div className="activities-grid">
              {CATEGORIES.map((cat) => (
                <label key={cat} className={`activity-item ${category === cat ? "selected" : ""}`}>
                  <input
                    type="radio"
                    name="category"
                    value={cat}
                    onChange={(e) => setCategory(e.target.value)}
                    style={{ display: 'none' }}
                  />
                  <span>{cat}</span>
                </label>
              ))}
            </div>
          </div>

          <textarea
            placeholder="Description..."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />

          {/* This section uses setIsPrivate to fix the Netlify error */}
          <div style={{ margin: '15px 0', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <input 
              type="checkbox" 
              id="private-toggle"
              checked={isPrivate} 
              onChange={(e) => setIsPrivate(e.target.checked)} 
            />
            <label htmlFor="private-toggle" style={{ cursor: 'pointer' }}>
              Make this group private
            </label>
          </div>

          <div className="button-group">
            <button type="button" className="secondary" onClick={() => navigate("/home")}>
              Cancel
            </button>
            <button type="submit">Create Group</button>
          </div>
        </form>
      </div>
    </div>
  );
}